<!-- Menu.svelte -->

<script>
	import { filtro_cate } from './store.js';
	import {execQuery} from './csql.js'

	//export let setview = ''
	export let handler = () => console.log("Unhandled action")

	let ds = []
	let loading=false

	let filtro_categoria = 'TODO'

	$: categorias = async () => {
		loading = true
		let query = `select * from config where tabla='categorias' and activo=1`
		const data = await execQuery({query})
		loading= false
		return data.data[0] || []
	}

	function set_filtro_cate(cate){
		filtro_cate.set(cate)
		setview('catalogo')
	}

	function elegir(c){
		filtro_cate.set(c)
		handler({response:0,view_dst:'catalogo'})
	}

	function faq(){
			handler({response:0,view_dst:'faq'})
	}

</script>
<div class="container">

	{#await categorias()}
		<div class="spinner"></div>
		{:then rs}


			<div class="row text-center" style="display: flex;justify-content: center;">
				
				{#each rs as cate, index}
					<!-- <div class="col-sm" on:click={()=>elegir(cate.codigo)}> -->
						<div class="card small__ xh-center v-center hovered"
							on:click={()=>elegir(cate.codigo)}
							style="margin:10px;min-height:400px;min-width:400px;border-radius:5px;background-color:#FCF3CF;background-repeat: no-repeat;
							background-size:cover;background-image: url('images/{cate.codigo.toLowerCase()}.png');background-color: white;cursor: pointer;">
							<!--h3 class="titulo">{cate.nombre}</h3-->
							<button style="position:relative;top:320px;">Shop</button>
							<!-- <h6 style="color:black;font-weight:bolder">{cate.nombre}</h6> -->
							<!-- <p style="color:red"><em>{cate.nombre.toUpperCase()}</em></p> -->
						</div>
					<!-- </div> -->
				{/each}

				<div class="card small__ xh-center v-center hovered"  on:click={faq}
					style="margin:10px;min-height:400px;min-width:400px;border-radius:5px;background-color:#FCF3CF;background-repeat: no-repeat;
							background-size:cover;background-image: url('images/faq.png');background-color: white;cursor: pointer;">
							<button style="position:relative;top:320px;">Shop</button>
							<!--h3 class="titulo">Dudas y Consultas</h3>
							<img src="images/faq.png" alt="" width="420px"-->
				</div>

			</div>
	{/await}
</div>

<style>
	.titulo{
		border-radius: 6px;
		/*border: 2px solid white;
		color:white;
		background-color:#555;*/
		padding:40px 8px;
	}
</style>
